import React, { useContext, useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { ChevronRight } from "react-feather"
import { categories, sliderItems } from '@/dummydata'
import Button from "@/components/Button"
import Container from "@/components/Container"
import CategoryList from "@/ui/CategoryList"
import ProductList from "@/ui/ProductList"
import Newsletter from "@/ui/Newsletter"
import Slider from "@/ui/Slider"
import api from '../api'
import { CartContext, UserContext } from "@/App"
import Carousel from '../components/Carousel'
import AboutUs from '../ui/AboutUs'
import { useGlobalData } from '../context/globalContext'

export default function HomePage() {
	const {user} = useContext(UserContext)
	const {cartDispatch} = useContext(CartContext)
	const [products, setProducts] = useState([])
	const [categories, setCategories] = useState([])
	const  websiteDetails  = useGlobalData();
	const webDetails = websiteDetails.websiteDetails
	const bannerImages = webDetails?.banner_img
		?.split(";")
		?.map((img, index) => ({
			id: index,
			image: img.replace("thumb_", "")
		}));
		// console.log("bannerimages",bannerImages)

	useEffect(() => {
		(async () => {
			const resp = await api.fetchProducts("",true)
			// console.log("products",resp)
			if (resp.status !== "error") {
				setProducts(resp)
			}
		})
		()
	}, [])

	useEffect(() => {
		(async () => {
			const catResp = await api.fetchCategories()
			// console.log("categories",catResp)
			if (catResp.status !== "error") {
				const filtered = catResp.filter((cat)=> cat.parentId == 1)
				setCategories(filtered)
			}
		})
		()
	}, [])

	useEffect(() => {
  if (location.hash) {
    const el = document.getElementById(location.hash.replace("#", ""));
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
}, [location]);

  const addToCart = async (product, quantity=1) => {
		if (user) {
			const resp = await api.addProductsToCart([{product:product, quantity}])
			if (resp) {
				cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
			}
		} else {
			cartDispatch({type: "ADD_PRODUCTS", payload: [{...product, quantity}]})
		}
	}
	
	return (
		<main>
			<section>
				<Carousel slides={bannerImages} />
			</section>

			<Container  id="categories" heading="Popular Categories">
				<CategoryList categories={categories} />
			</Container>

			<Container  id="aboutus" heading ="About Us">
				<AboutUs />
			</Container>

			<Container id= "products"heading="Latest Arrivals">
				<ProductList products={[...products].slice(0,4)} onAddToCart={addToCart} />

				<Link to="/products" className="flex justify-center">
					<Button className="text-lg mt-6" link>
						View More <ChevronRight className="ml-2" />
					</Button>
				</Link>
			</Container>

			{/* <section className="my-20">
				<Newsletter />
			</section> */}
		</main>
	)
}